export const QUOTA_EXCEEDED = "QuotaExceededError";
export const INVALID_ROUTE_PROPERTIES = "Invalid route properties-- route or component is required";
